import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Profile } from 'src/app/models/profile.model';

@Injectable({
  providedIn: 'root'
})
export class StatefulService {
  private reloadDashboardSubject = new Subject<Profile>();
  public reloadDashboardListener$ = this.reloadDashboardSubject.asObservable();

  constructor() {}

  public reloadDashboard(profile: Profile): void {
    this.reloadDashboardSubject.next(profile);
  }

}
